var moment = require('moment-timezone');

var GuestServiceModel = Backbone.Epoxy.Model.extend({

  initialize: function() {
    Backbone.Validation.bind(this, { liveValidation: true });
  },

  defaults: {
    index: 0,
    totalEstimatedTime: 0,
    employee: null,
    service: null,
    firstName: null,
    lastName: null,
    phone: null,
    statusInService: false,
    expectedWaitTimeMins: null,
    estimatedServiceTime: 0,
    suggestedArrivalTime: 0,
    currentWaitTime: null,
    enteredWaitListAt: 0,
    parentModel: null
  },

  computeds: {
    serviceName: function() {
      var service = this.get('service');
      if (service == null) {
        return null;
      }
      return service.get('name');
    },

    employeeName: function() {
      var employee = this.get('employee');
      if (employee == null) {
        return null;
      }
      return employee.displayName;
    },

    hasEmployee: function() {
      return this.get('employee') != null;
    },

    employeePhoto: function() {
      var employee = this.get('employee');
      if (employee == null) {
        return null;
      }
      return bookedby.helpers.employeePhoto(employee, 'small');
    },

    fullName: {
      deps:['firstName', 'lastName'],
      get: function(firstName, lastName) {
        return firstName + ' ' + lastName;
      }
    }
  },

  validation: {
    firstName: [
      {
        required: true,
        msg: 'Please enter guest\'s first name'
      }
    ],
    lastName: [
      {
        required: true,
        msg: 'Please enter guest\'s last name'
      }
    ]
  },

  getWaitTimeToArrival: function(parentModel) {
    var expectedWaitTimeMins = this.get('expectedWaitTimeMins');
    if (!_.isNull(expectedWaitTimeMins)) {
      return expectedWaitTimeMins + " min.";
    }

    if (!parentModel.get('storeTimeZone') || !this.get('enteredWaitListAt') || !this.get('estimatedServiceTime')) {
      console.warn('returning earlier');
      return;
    }

    var serviceTime = bookedby.helpers.getNewMomentWithTimeOfDayBySecond(moment().tz(parentModel.get('storeTimeZone')), this.get('estimatedServiceTime'));
    var enteredTime = bookedby.helpers.getNewMomentWithTimeOfDayBySecond(moment().tz(parentModel.get('storeTimeZone')), this.get('enteredWaitListAt'));

    var waitTime = serviceTime.diff(enteredTime, 's');

    if (waitTime < 0) {
      waitTime = 0;
    }

    this.get('currentWaitTime').add(30, 's');
    console.warn('returning');
    console.log(bookedby.helpers.timeToDuration(waitTime).partialTime);
    return bookedby.helpers.secondsToMinutesRoundable(waitTime, 1) + ' min.'; //bookedby.helpers.timeToDuration(waitTime).partialTime;

  }

});

module.exports = GuestServiceModel;
